<template>
  <div class="mb-3">
    <div class="d-flex justify-content-center" v-if="loading">
      <CSpinner color="info" />
    </div>

    <div v-else>
      <h5>
        {{ $t("family.dashboard.products.selling") }} {{ n_products }}
        {{ $t("role.dashboard.common.products.products") }}
        {{ $t("family.dashboard.map.and") }} {{ n_lots }}
        {{ $t("role.dashboard.common.products.variants") }}
      </h5>
      <div
        v-if="dataset.length > 0"
        :style="{ position: 'relative' }"
        class="bg-gray-100 p-2 rounded"
      >
        <CChartHorizontalBar
          :datasets="defaultDatasets"
          :labels="defaultLabels"
          :options="options"
          :plugins="chartPlugins"
        />
      </div>
      <div class="w-100 pl-2 pt-2 mb-3">
        <router-link
          :to="{
            name: 'RoleProductsShowcase',
            params: { id: roleId },
          }"
          >{{ $t("family.dashboard.products.viewProducts") }} →</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import { CChartHorizontalBar } from "@coreui/vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { apiGet } from "../../helpers/apiHelper";

export default {
  data() {
    return {
      loading: false,
      dataset: [],
      n_products: null,
      n_lots: null,
      chartPlugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        layout: {
          padding: { left: 0, right: 0 },
        },
        plugins: {
          datalabels: {
            display: true,
            anchor: "end",
            align: "right",
            color: "#555",
            font: { size: 11, weight: "bold" },
            padding: 4,
            formatter: (value, ctx) => {
              return `${value}`;
            },
          },
        },
        scales: {
          xAxes: [{ gridLines: { display: false }, ticks: { display: false } }],
          yAxes: [
            {
              gridLines: { display: false },
              ticks: { display: true, fontSize: 12 },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    roleId(newRoleId, oldRoleId) {
      if (newRoleId != oldRoleId) {
        this.getData();
      }
    },
  },
  methods: {
    async getData() {
      const self = this;
      this.loading = true;

      const roleId = this.roleId;

      const response = await apiGet("role_market_dash_pp", [roleId]);

      if (response && response.data && response.status === 200) {
        self.loading = false;
        self.dataset = response.data.data;
        self.n_products = response.data.products;
        self.n_lots = response.data.lots;
      } else {
        self.loading = false;
      }
    },
  },
  components: {
    CChartHorizontalBar,
  },
  computed: {
    roleId() {
      return this.$store.state.role.id;
    },
    defaultDatasets() {
      const mutedPalette = [
        "rgba(190, 110, 100, 0.75)",
        "rgba(90, 150, 175, 0.75)",
        "rgba(110, 160, 110, 0.75)",
        "rgba(175, 145, 90, 0.75)",
        "rgba(150, 110, 175, 0.75)",
        "rgba(90, 170, 155, 0.75)",
        "rgba(200, 155, 100, 0.75)",
        "rgba(120, 140, 170, 0.75)",
      ];
      const list_products = this.dataset.map((d) => d.value);
      const list_colors = this.dataset.map(
        (_, i) => mutedPalette[i % mutedPalette.length]
      );
      return [
        {
          backgroundColor: list_colors,
          data: list_products,
          datalabels: {},
        },
      ];
    },
    defaultLabels() {
      let list_labels = [];
      this.dataset.forEach(function (data, index) {
        list_labels.push(data.label);
      });
      return list_labels;
    },
  },
};
</script>
